// PROTOTYPE
// This Component is highly subject to change
import React from 'react'
import { css, keyframes } from 'emotion'
import PropTypes from 'prop-types'
import ScrollView from 'src/components/utils/ScrollView'

const fadeIn = keyframes`
  0% {
    background-color: rgba(0,0,0,0);
  }

  40% {
    background-color: rgba(0,0,0,0.07);
  }

  100% {
    background-color: rgba(0,0,0,0);
  }
`

const ProtoColumnC = ({ children }) => (
   <ScrollView
      className={css`
         background-color: rgb(247, 247, 245);

         @media (min-width: 1350px) {
            animation: ${fadeIn} 3s ease;
         }
      `}
      position="absolute"
      top="0px"
      left="0px[a-d] 300px[e-f]"
      right="0px"
      bottom="0px"
      scroll="on">
      {children}
   </ScrollView>
)

ProtoColumnC.propTypes = {
   children: PropTypes.node.isRequired
}

export default ProtoColumnC
